module.exports = __webpack_public_path__ + "img/racetrack-vaal-turf.4d815ec5.svg";